// removed by extract-text-webpack-plugin
module.exports = {"container":"SectionIntro__container___2SkrW","image":"SectionIntro__image___YUwz0","body":"SectionIntro__body___J8bac _typography__p___312so _typography__content___3raTl","body-light":"SectionIntro__body-light___1W_qn SectionIntro__body___J8bac _typography__p___312so _typography__content___3raTl","footer":"SectionIntro__footer___38ntB","header":"SectionIntro__header___hWWt5 _typography__h2___3ZgWa _typography__headers___eO5yD","header-light":"SectionIntro__header-light___18TpX SectionIntro__header___hWWt5 _typography__h2___3ZgWa _typography__headers___eO5yD"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Layout/SectionIntro.scss
// module id = 552
// module chunks = 0